import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        map: {
            height: '100%',
        },
        animatedCrosshair: {
            // skip
        },
    });
});
